import { THistoryDiffData } from '../../../../types/history';
import {
  TSiteTaskHistoryListData,
  TSiteTaskHistoryDiffApiResponse
} from '../../../../types/task';
import {
  getSiteProcessStatusName,
  getOrderCategoryName,
  createSiteTaskFormOrderDisplayName
} from '../../../../utils';

export const useHooks = () => {
  const createHistoryDiffData = (
    targetId: number,
    title: string,
    hasDiff: boolean,
    target: string | number | null | undefined,
    previous: string | number | null | undefined
  ) => {
    return {
      targetId,
      title,
      hasDiff,
      target,
      previous
    };
  };

  const createHistoryDiffDataList = (
    apiResponseHistoryDiff: TSiteTaskHistoryDiffApiResponse
  ) => {
    const target = apiResponseHistoryDiff.data.target_site_task_history;
    const previous = apiResponseHistoryDiff.data.previous_site_task_history;
    const historyDiffDataList: Array<THistoryDiffData> = [];

    historyDiffDataList.push(
      createHistoryDiffData(
        target?.id,
        '工程名',
        target?.site_process?.id !== previous?.site_process?.id,
        target?.site_process?.name,
        previous && previous?.site_process?.name
      )
    );

    historyDiffDataList.push(
      createHistoryDiffData(
        target?.id,
        'タスク',
        target?.site_task_name !== previous?.site_task_name,
        target?.site_task_name,
        previous && previous?.site_task_name
      )
    );

    historyDiffDataList.push(
      createHistoryDiffData(
        target?.id,
        '担当者',
        target?.charge_user?.id !== previous?.charge_user?.id,
        target?.charge_user?.name,
        previous && previous && previous?.charge_user?.name
      )
    );

    historyDiffDataList.push(
      createHistoryDiffData(
        target?.id,
        '期限',
        target?.planned_end_date !== previous?.planned_end_date,
        target?.planned_end_date,
        previous?.planned_end_date
      )
    );

    historyDiffDataList.push(
      createHistoryDiffData(
        target?.id,
        '内容',
        target?.detail !== previous?.detail,
        target?.detail,
        previous?.detail
      )
    );

    historyDiffDataList.push(
      createHistoryDiffData(
        target?.id,
        '発注書カテゴリ',
        target?.order_category !== previous?.order_category,
        getOrderCategoryName(target?.order_category),
        getOrderCategoryName(previous?.order_category)
      )
    );

    historyDiffDataList.push(
      createHistoryDiffData(
        target?.id,
        '発注書名',
        target?.order?.id !== previous?.order?.id,
        target?.order
          ? createSiteTaskFormOrderDisplayName(target?.order)
          : null,
        previous?.order
          ? createSiteTaskFormOrderDisplayName(previous?.order)
          : null
      )
    );

    historyDiffDataList.push(
      createHistoryDiffData(
        target?.id,
        'ステータス',
        target?.status !== previous?.status,
        getSiteProcessStatusName(target?.status),
        getSiteProcessStatusName(previous?.status)
      )
    );

    historyDiffDataList.push(
      createHistoryDiffData(
        target?.id,
        '完了日',
        target?.actual_end_date !== previous?.actual_end_date,
        target?.actual_end_date,
        previous?.actual_end_date
      )
    );

    return historyDiffDataList;
  };

  const createHistoryDataText = (
    apiResponseHistory: TSiteTaskHistoryListData
  ): string => {
    return apiResponseHistory.site_task_name;
  };

  return {
    createHistoryDiffDataList,
    createHistoryDataText
  };
};
